import { Expose, Type } from 'class-transformer';
import { EventWithRelationsImpl } from '../implements/event-with-relations.impl';

export class GetEventsByFilterResponseDto {
  @Expose({ name: 'events' })
  @Type(() => EventWithRelationsImpl)
  events: EventWithRelationsImpl[];
  @Expose({ name: 'totalPages' })
  totalPages: number;
  @Expose({ name: 'totalResults' })
  totalResults: number;
}
